import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { SearchOptionsState, SharedApplicationState } from '../shared-state.interface';
import { SearchOptions } from './search-options.entity';
import { searchOptionsAdapter } from './search-options.reducer';

export const getSearchOptionsState: MemoizedSelector<
    object,
    SearchOptionsState,
    DefaultProjectorFn<SearchOptionsState>
> = createFeatureSelector<SearchOptionsState>('searchOptions');

const { selectAll, selectEntities } = searchOptionsAdapter.getSelectors(getSearchOptionsState);

export const selectSearchOptions: (state: SharedApplicationState) => SearchOptionsState = (
    state: SharedApplicationState
) => state.searchOptions;

export function getSearchOptions(
    id: string
): MemoizedSelector<object, SearchOptions | undefined, DefaultProjectorFn<SearchOptions | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<SearchOptions>) => entries[id]);
}

export const searchOptionsSelector: MemoizedSelector<
    object,
    Dictionary<SearchOptions>,
    DefaultProjectorFn<Dictionary<SearchOptions>>
> = createSelector(selectEntities, (entries: Dictionary<SearchOptions>) => entries);
